import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import Button from 'orionsoft-parts/lib/components/Button'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import autobind from 'autobind-decorator'
import MdAccessTime from 'react-icons/lib/md/access-time'
import MdCancel from 'react-icons/lib/md/cancel'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'
import FileBinary from 'react-icons/lib/go/file-binary'
import includes from 'lodash/includes'
import FaceData from '../FaceData'

@withMutation(gql`
  mutation createAlert($documentId: String) {
    createAlert(documentId: $documentId) {
      success
    }
  }
`)
@withMutation(gql`
  mutation confirmCheckAttachments($documentId: ID) {
    confirmCheckAttachments(documentId: $documentId) {
      success
    }
  }
`)
@withMutation(gql`
  mutation requiresAttachmentsCheck($documentId: ID) {
    requiresAttachmentsCheck(documentId: $documentId) {
      success
    }
  }
`)

@withMutation(gql`
  mutation initFeaFlow($documentId: ID!, $organizationId: ID) {
    initFeaFlow(documentId: $documentId, organizationId: $organizationId)
  }
`)

@withMutation(gql`
  mutation cancelDocument($documentId: ID, $rejectReason: String) {
    cancelDocument(documentId: $documentId, rejectReason: $rejectReason) {
      _id
    }
  }
`)

@withMessage
@withRouter
export default class Buttons extends React.Component {
  state={}

  static propTypes = {
    showMessage: PropTypes.func,
    router: PropTypes.object,
    document: PropTypes.object,
    params: PropTypes.object,
    url: PropTypes.bool,
    cancelDocument: PropTypes.func,
    createAlert: PropTypes.func,
    confirmCheckAttachments: PropTypes.func,
    requiresAttachmentsCheck: PropTypes.func,
    sendAdjuntosRevisados: PropTypes.func,
    initFeaFlow: PropTypes.func
  }

  @autobind
  async alert() {
    this.setState({ loading: true, errorMessages: null })
    try {
      await this.props.createAlert({ documentId: this.props.document._id })
      this.props.showMessage('Se ha enviado un recordatorio')
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, { level: 'error' })
    }
    this.setState({ loading: false })
  }

  @autobind
  async consultasRequiereRevisarAdjuntos() {
    // console.log("Voy por consultasRequiereRevisarAdjuntos");
    let resultado = await this.props.requiresAttachmentsCheck({documentId: this.props.document._id})
    // console.log("Volvio consultasRequiereRevisarAdjuntos");
    resultado = resultado.requiresAttachmentsCheck.success
    this.setState({ mustCheckAttachments: resultado })
    this.setState({ loaded: true })
  }

  @autobind
  async marcarAdjuntosRevisados() {
    var result = await this.props.confirmCheckAttachments({documentId: this.props.document._id})
    this.setState({checkingAttachments: false})
    this.setState({confirmadoCheckDeAdjuntos: result.confirmCheckAttachments.success})
  }

  gotoFirmar() {
    if (this.state.mustCheckAttachments && !this.state.confirmadoCheckDeAdjuntos) {
      alert('Debe confirmar que ha revisado los archivos adjuntos.')
      return
    }
    this.props.router.push(`/sign/${this.props.document._id}`)
  }

  sendAdjuntosRevisados() {
    this.setState({checkingAttachments: true})
    this.marcarAdjuntosRevisados()
  }

  renderReviewAttachments() {
    console.log('renderReviewAttachments ', this.state)
    if (this.state.mustCheckAttachments) {
      return (
        <Button className={styles.btnCheckAttachments}
          tooltip={'Confirmar revisión de documentos adjuntos'}
          loading={this.state.checkingAttachments}
          hidden={ !this.state.mustCheckAttachments || this.state.confirmadoCheckDeAdjuntos}
          primary
          onClick={() =>
            this.sendAdjuntosRevisados()
          }
        >
          He revisado los archivos adjuntos
        </Button>
      )
    }
  }

  componentDidMount() {
    this.consultasRequiereRevisarAdjuntos()
  }

  renderPreviewButton() {
    const renderLink = this.props.url ? `/admin/${this.props.params._id}/${this.props.params.documentId}/preview` : `/documents/${this.props.params.documentId}/preview`
    //console.log("El documento:", this.props.document);
    
    if(this.props.document.hasPreview)
    return (
      <div className="col-xs-12 col-md-4 start-md">
        <p>
          <Button
            onClick={() => {
              this.props.router.push(renderLink)
            }}
          >
          Ver documento
          </Button>
        </p>
      </div>
    )
  }

  renderFeaButton() {
    // console.log("Rejected: ", this.props.document.rejected)
    if (this.props.document.rejected) {
      return
    }
    let iFea = this.props.document.feaSignAuthorization
    let nextFea = this.props.document.feaNextSigner
    // console.log('PermisosFEA: ' + nextFea + ' - ' + iFea);
    let mensajeNext = 'Aún no es tu turno para aplicar la firma'
    if (nextFea) { mensajeNext = 'Serás redirigido eCertChile' }
    // console.log("Next Fea: "+ nextFea);
    if (this.props.document.ready && this.props.document.faceReady && this.props.document.bioReady && iFea) {
      return (
        <div className="col-xs-12 end-md">
          <div className={styles.feaState}>
            <Tooltip content={mensajeNext}>
              <Button onClick={() => { this.gotoECert() } } loading={this.state.fealoading}
                disabled={!nextFea} primary><FileBinary size={20} style={{color: '#3cb371'}}/>&nbsp;Ver y aplicar firma avanzada</Button>
            </Tooltip>
          </div>
        </div>
      )
    } else {
      return (
        <div className="col-xs-6 col-sm-6"></div>
      )
    }
  }

  @autobind
  async cancelarDocumento() {
    this.setState({rechazando: true})
    console.log('cancelarDocumento', this.props.document);

    if (this.props.document.transactionId && this.props.document.transactionId.length > 0) {
      const result = window.confirm('El documento es parte de una transacción, si lo rechaza se rechazará la transacción completa')
      if (!result) {
        this.setState({rechazando: false})
        return
      }
    }

    const razonRechazo = prompt('Por favor indicanos la razon del rechazo')
    if (!razonRechazo || razonRechazo.trim() === '') {
      alert('Debe dar una razon para el rechazo')
      this.setState({rechazando: false})
      return
    }
    console.log('Razon de rechazo es ' + razonRechazo)
    try {
      await this.props.cancelDocument(
        {
          rejectReason: razonRechazo,
          documentId: this.props.document._id,
          otroCampo: '12345'
        },
        {
          refetchQueries: [
            'getDocument',
            'documentCount',
            'organizationDocCount',
            'myDocumentsToSign',
            'myFeaDocumentsToSign',
            'planSignaturesCount',
            'packsSignaturesCount'
          ]
        }
      )
      console.log('Vuelve cancelDocument!')
      this.props.showMessage('Documento rechazado')
      setTimeout(() => {
        this.props.router.push(`/documents`)
      }, 4000
      )
    } catch (error) {
      console.log(error.message)
      this.setState({rechazando: false})
      if (includes(error.message, 'verify')) {
        this.refs.alert.toggleDialog('OutlineModal')
      } else {
        this.props.showMessage(error.message, {level: 'error'})
      }
    }
  }

  renderCancelButton() {
    if (this.props.document.rejected) {
      return (
        <div className="col-xs-12 col-sm-12 start-md">
          <p>
            <Button
              className={styles.btnCancelar}
              primary
              disabled
            >
                Motivo del rechazo: {this.props.document.rejected.reason}
            </Button>
          </p>
        </div>
      )
    }
    if (this.props.document.documentOwner && (!this.props.document.ready || !this.props.document.feaReady || !this.props.document.bioReady)) {
      return (
        <div className="col-xs-6 start-md">
          <Button className={styles.btnCancelar}
            loading={this.state.rechazando}
            primary
            onClick={this.cancelarDocumento}>
            Rechazar Documento
          </Button>
        </div>
      )
    } else {
      return null
    }
  }

  @autobind
  async gotoECert() {
    this.setState({ fealoading: true })
    try {
      localStorage.setItem('active', true)
      localStorage.setItem('docId', this.props.document._id)
      localStorage.setItem('docLink', window.location.href.split('?')[0].split('#')[0])
      let feaFlowResponse = await this.props.initFeaFlow({documentId: this.props.document._id, organizationId: null})
      this.props.showMessage('Re dirigiendo para firma electrónica avanzada')
      let newUrl = feaFlowResponse.initFeaFlow.ecertSignUrl
      localStorage.removeItem('docLink')
      localStorage.removeItem('docId')
      localStorage.removeItem('active')
      window.location.href = newUrl
    } catch (e) {
      this.props.showMessage(e.message, {level: 'error'})
      this.setState({ fealoading: false })
      if (e.message.indexOf('perfil') > 0) {
        setTimeout(this.props.router.push(`/settings`), 5000)
      }
      // ccastellanos@vincitrent.cl
    } finally {
    }
  }

  renderRemindToSign() {
    return this.props.document.documentOwner && !this.props.document.rejected ? (
      <div className="col-xs-6 end-md">
        <div className={styles.btnHeader}>
          <Button
            primary
            onClick={this.alert}
            loading={this.state.loading}
          >
            Recordar firma
          </Button>
        </div>
      </div>
    ) : null
  }

  renderDocState() {
    return !this.props.document.rejected ? (
      <div className="col-xs-12 col-md-8 start-md">
        <div className={styles.state}>
          <MdAccessTime size={30} style={{ color: '#0069ff', 'margin-right': '.3em' }} />
          El documento aún no ha sido firmado por todos los participantes
        </div>
      </div>
    ) : (
      <div className="col-xs-12 col-md-8 start-md">
        <div className={styles.state}>
          <MdCancel size={30} style={{ color: '#FF0000', 'margin-right': '1em' }} />
          El documento ha sido rechazado
        </div>
      </div>
    )
  }

  renderSeeAndSign() {
    console.log('===== renderSeeAndSign =====')
    // console.log("faceAuthorization " + this.props.document.faceSignAuthorization);
    if (this.props.document.signAuthorization) {
      console.log('===== signAuthorization =====')
      return (
        <div className='col-xs-12 end-md'>
          <Button
            className={styles.sign}
            primary
            hidden={ this.props.document.ready || !this.state.loaded || (this.state.mustCheckAttachments && !this.state.confirmadoCheckDeAdjuntos) || this.props.document.rejected }
            onClick={() =>
              this.gotoFirmar()
            }
          >
            Ver y Firmar Documento
          </Button>
          {this.renderReviewAttachments()}
        </div>
      )
    } else if (this.props.document.faceSignAuthorization) {
      return (
        <div className='col-xs-12 end-md'>
          <FaceData documentId={this.props.document._id} document={this.props.document}/>
        </div>
      )
    }
  }

  render() {
    return (
      <div className={styles.container}>
        <div className="content">
          <div className="row">
            {this.renderDocState()}
            {/* {this.renderCopyURL()} */}
          </div>
          <div className="row">
            {this.renderPreviewButton()}
          </div>
          <div className="row">
            {this.renderFeaButton()}
          </div>
          <div className="row">
            {this.renderSeeAndSign()}
          </div>
          <div className="row">
            {this.renderCancelButton()}
            {this.renderRemindToSign()}
          </div>
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Document/Status/Title/Buttons/index.js